import { Environment } from "../Environment";
import "./EnvInfo.css";

export default function EnvInfo() {
    let title = Environment.isDev ? "DEV" : "STAGING";
    if (Environment.project) title += " " + Environment.project;

    return Environment.isDev || Environment.isTest ? <div className="env-info">{title}</div> : null;
}
